<template>
  <v-dialog :value="value" max-width="360" @input="$emit('input', $event)">
    <v-card class="text-center">
      <v-card-title class="text-subtitle-1 justify-center">
        Утсандаа нэвтрэх
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-5">
        <div v-if="done" class="py-8">
          <v-icon size="46" color="green">mdi-check-circle-outline</v-icon>
          <p class="mt-3 mb-0 text-body-2">Апп дээр нэвтэрлээ</p>
        </div>

        <div v-else-if="code">
          <div class="qr-box mx-auto">
            <qr-code :text="code" :size="188" error-level="M" />
          </div>
          <p class="mt-4 mb-1 text-body-2">
            Аппликэйшны → <b>QR-аар нэвтрэх</b> товч дээр дараад энэ QR кодыг уншуулна уу!
          </p>
          <p class="text-caption grey--text mb-0">
            Код нэг л удаа ажиллана
          </p>
        </div>

        <div v-else class="py-10">
          <v-progress-circular indeterminate color="green" size="28" />
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-btn text small @click="start">Шинэ код</v-btn>
        <v-spacer />
        <v-btn text @click="close">Хаах</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sync } from "vuex-pathify";
import QrCode from "vue-qrcode-component";
import { createSession, watchSession, dropSession } from "./qr_login.js";

export default {
  name: "QrLoginDialog",
  components: { QrCode },
  props: { value: Boolean },
  data() {
    return { code: "", sessionId: "", done: false, stopWatching: null };
  },
  computed: {
    ...sync("*"),
  },
  watch: {
    value(open) {
      if (open) this.start();
      else this.stop();
    },
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    stop() {
      if (this.stopWatching) this.stopWatching();
      this.stopWatching = null;
    },
    async start() {
      this.stop();
      this.code = "";
      this.done = false;
      if (!this.userData || !this.userData.ref) return;

      const session = await createSession(this.userData);
      this.sessionId = session.id;
      this.code = session.code;

      this.stopWatching = watchSession(session.id, () => {
        this.done = true;
        this.stop();
      });
    },
    close() {
      // An unused code is worth nothing once this dialog is closed.
      if (!this.done && this.sessionId) dropSession(this.sessionId);
      this.stop();
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.qr-box {
  width: 210px;
  padding: 11px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}
</style>
